var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33404 2.33247C3.05742 2.05584 2.60892 2.05584 2.3323 2.33247C2.05568 2.60909 2.05568 3.05758 2.3323 3.3342L4.04942 5.05132C3.03603 5.81356 2.15264 6.86051 1.49128 8.18323C1.39158 8.38264 1.39158 8.61736 1.49128 8.81678C3.02002 11.8743 5.73512 13.4583 8.49984 13.4583C9.6014 13.4583 10.6951 13.2069 11.709 12.7109L13.6656 14.6675C13.9423 14.9442 14.3907 14.9442 14.6674 14.6675C14.944 14.3909 14.944 13.9424 14.6674 13.6658L3.33404 2.33247ZM10.6346 11.6365C9.94078 11.9079 9.21765 12.0417 8.49984 12.0417C6.39695 12.0417 4.24846 10.8936 2.92501 8.5C3.50411 7.45263 4.24118 6.64374 5.06327 6.06517L6.58193 7.58383C6.44918 7.86124 6.37484 8.17194 6.37484 8.50001C6.37484 9.67361 7.32623 10.625 8.49984 10.625C8.8279 10.625 9.1386 10.5507 9.41601 10.4179L10.6346 11.6365Z",
    fill: "#0067DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.141 9.84263C13.4832 9.44928 13.7971 9.00204 14.0746 8.5C12.7512 6.10639 10.6027 4.95833 8.49981 4.95833C8.42047 4.95833 8.34107 4.95997 8.26165 4.96324L6.99774 3.69933C7.49217 3.59444 7.99516 3.54167 8.49981 3.54167C11.2645 3.54167 13.9796 5.12575 15.5084 8.18322C15.6081 8.38264 15.6081 8.61736 15.5084 8.81678C15.123 9.58741 14.6624 10.2644 14.1445 10.8461L13.141 9.84263Z",
    fill: "#0067DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eye-close.f4ddc2c6.svg";
export { ForwardRef as ReactComponent };